module.exports = __webpack_public_path__ + "img/banner_dummy_hiking.c2026c40.png";